import { EnquiryTicket, SaleTicket } from "data/types"
import { sendEmail } from "./mailer"

export const addNewContact = async (email: string, name: string, contactPhone?: string) => {
    const URL = process.env.REACT_APP_API_URL
    const resp = await fetch(`${URL}/contact/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },

        body: JSON.stringify({ email, name, contactPhone })
    })

    return resp
}

export const addSubscription = async (email: string) => {
    const URL = process.env.REACT_APP_API_URL
    const resp = await fetch(`${URL}/contact/subscribe`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },

        body: JSON.stringify({ email: email })
    })

    const data = await resp.json()
    if (resp.status === 200 && data) {
        return data
    }

}

export const createEnquiryTicket = async (ticket: EnquiryTicket) => {
    const { email, name, contactPhone } = ticket
    const URL = process.env.REACT_APP_API_URL

    sendEmail(ticket, "enquiry")

    try {
        const contact = await addNewContact(email, name, contactPhone)

        const data = await contact.json()
        if (data && data.contact) {
            const { id } = data.contact

            const resp = await fetch(`${URL}/contact/ticket`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ...ticket, contactId: id })
            })

            const ticketData = await resp.json()
            if (resp.status === 200 && ticketData) return ticketData
            return false
        }
    } catch (error) {
        console.log(error)
        return error
    }
}

export const createSellCarTicket = async (ticket: SaleTicket) => {
    const { email, name, contactPhone } = ticket
    const URL = process.env.REACT_APP_API_URL

    sendEmail(ticket, "sale")

    try {
        const contact = await addNewContact(email, name, contactPhone)

        const data = await contact.json()
        if (data && data.contact) {
            const { id } = data.contact

            const resp = await fetch(`${URL}/contact/ticket/sale`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ...ticket, contactId: id })
            })

            const ticketData = await resp.json()
            if (resp.status === 200 && ticketData) return ticketData
            return false
        }
    } catch (error) {
        console.log(error)
        return error
    }
}

